
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { getPublishedPosts } from '@/data/blogPosts.index';
import BlogCard from '@/components/blog/BlogCard';

const Blog = React.memo(() => {
  // Get only the latest 3 published posts (exclude drafts)
  const latestPosts = getPublishedPosts().slice(0, 3);

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#422680] via-[#660F56] to-[#F54952] bg-clip-text text-transparent">
              Latest Insights
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay informed with expert analysis and industry trends
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {latestPosts.map((post, index) => (
            <BlogCard key={post.id} post={post} variant="home" index={index} />
          ))}
        </div>

        <div className="text-center">
          <Link to="/blog">
            <Button 
              variant="outline"
              className="border-2 border-[#422680] text-[#422680] hover:bg-[#422680] hover:text-white"
            >
              View All Articles
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
});

Blog.displayName = 'Blog';
export default Blog;
